/**
 * Waits for all animations on the given element to complete.
 *
 * @param element - The HTML element whose animations are being tracked.
 * @returns A promise that resolves when all animations are settled.
 */
export const animationsComplete = (element: HTMLElement) =>
  Promise.allSettled(
    element.getAnimations().map(animation => animation.finished),
  );
